import { defineMessages } from "@edx/frontend-platform/i18n";

const messages = defineMessages({
  loading: {
    id: "learn.staticTab.loading",
    defaultMessage: "Loading...",
    description: "Message shown while loading static tab content",
  },
  errorLoadingContent: {
    id: "learn.staticTab.errorLoadingContent",
    defaultMessage: "Error loading tab content. Please try again later.",
    description: "Error message shown when static tab content fails to load",
  },
});

export default messages;
